import { AlarmIcon } from 'src/assets/icons'
import { GlobalStatisticItem } from '../global-statistics-item.component'
import { useAccountTopStatsViews } from 'src/hooks'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
  timeframe: number
}

const TotalViewsStatistic = (props: IProps) => {
  const { data: views, isLoading } = useAccountTopStatsViews(props)

  return (
    <GlobalStatisticItem
      title={<HelperWrapper t="dashboard-total-views-title" />}
      count={isLoading ? undefined : views?.total || 0}
      icon={AlarmIcon}
    />
  )
}

export { TotalViewsStatistic }
